export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.8b696b78.worker.js");
}
